import { useMutation } from '@tanstack/react-query';

import type {
  BookingRecurringEventFormData,
  BookingRecurringEventFormResponse,
  BookingRecurringEventMutationResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteBookingRecurringEventMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      id: number;
      deleteOnlyRecurring: boolean;
    }) =>
      HttpClient.request<BookingRecurringEventMutationResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
        data: {
          delete_only_recurring: params.deleteOnlyRecurring,
        },
      }),
  });

export const useBookingRecurringEventFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: BookingRecurringEventFormData;
    }) =>
      HttpClient.request<BookingRecurringEventFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
